import Hotjar from '@hotjar/browser';
import { isEmbedPage } from '@shared/embed/embed-protocol';

const HOTJAR_VERSION = 6;

/**
 * Starts Hotjar for the environment's site id; does nothing without one, or on the
 * embed page, so the extension's side-panel chats are not recorded.
 */
export function initHotjar(
  siteId: number | null,
  pathname = window.location.pathname
): void {
  if (siteId && !isEmbedPage(pathname)) {
    Hotjar.init(siteId, HOTJAR_VERSION);
  }
}
